import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AFEmploymentDomain } from '../model/af.model';
import { AuthService } from './auth.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class EmploymentService {

  constructor(private userService: AuthService, private http: HttpClient) {
  }

  getEmploymentHistory(): Observable<AFEmploymentDomain> {
    return this.http.post<AFEmploymentDomain>(environment.api_uri + 'getEmploymentHistory', { 'verifyId': this.userService.getVerifyId() }).pipe(
      map(response => {
        if (response.employmentVerificationDate) {
          response.employmentVerificationDate = new Date(response.employmentVerificationDate);
        }
        response.employmentList.forEach(item => {
          if (item.employmentStartDate) {
            item.employmentStartDate = new Date(item.employmentStartDate);
          }
          if (item.employmentEndDate) {
            item.employmentEndDate = new Date(item.employmentEndDate);
          }
        });
        response.employmentBreakList.forEach(item => {
          if (item.employmentBreakFromDate) {
            item.employmentBreakFromDate = new Date(item.employmentBreakFromDate);
          }
          if (item.employmentBreakToDate) {
            item.employmentBreakToDate = new Date(item.employmentBreakToDate);
          }
        });
        return response;
      }));
  }

  getReasonCodeForLeaving(reason): Observable<Object> {
    return this.http.get<Object>(environment.api_uri + 'getReasonCodeForLeaving?reason=' + reason);
  }

  saveFiles(fd: FormData) {
    const requestUrl = environment.api_uri + 'uploadApplicantAttachments';
    return lastValueFrom(this.http.post<any>(requestUrl, fd));
  }

  getMongoAttachments(attachmentId: string) {
    const requestUrl = environment.api_uri + 'downloadAttachment';
    return this.http.get(requestUrl + "?attachmentId=" + attachmentId, { responseType: 'blob', observe: 'response' })
  }

  submitEmploymentHistory(employmentHistory): Observable<AFEmploymentDomain> {
    const requestUrl = environment.api_uri + 'saveEmployment';
    if (employmentHistory.employmentVerificationDate) {
      employmentHistory.employmentVerificationDate = moment(employmentHistory.employmentVerificationDate).format('MM/DD/YYYY');
    }

    employmentHistory.employmentList.forEach(item => {
      if (item.employmentStartDate) {
        item.employmentStartDate = moment(item.employmentStartDate).format('MM/DD/YYYY');
      }
      if (item.employmentEndDate) {
        item.employmentEndDate = moment(item.employmentEndDate).format('MM/DD/YYYY');
      }
    });
    employmentHistory.employmentBreakList.forEach(item => {
      if (item.employmentBreakFromDate) {
        item.employmentBreakFromDate = moment(item.employmentBreakFromDate).format('MM/DD/YYYY');
      }
      if (item.employmentBreakToDate) {
        item.employmentBreakToDate = moment(item.employmentBreakToDate).format('MM/DD/YYYY');
      }
    });

    let params = new HttpParams().set("verifyId", this.userService.getVerifyId());
    return this.http.post<AFEmploymentDomain>(requestUrl, employmentHistory, { params });
  }
}



